<template>

  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button color="medium" :disabled="showBigButtons" @click="cancel()">{{ (showBigButtons) ? "" : t("Cancel") }}</ion-button>
      </ion-buttons>
      <ion-title>{{ props.title }}</ion-title>
      <ion-buttons slot="end">
        <ion-button :disabled="showBigButtons" @click="confirm()" :strong="true">{{ (showBigButtons) ? "" : t("Done") }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content>
    <div id="page">
      <ion-item>
        <ion-label>
          <h1>{{ alertHeader }}</h1>
          <p>{{ alertMessage }}</p>
        </ion-label>
      </ion-item>
      <div style="display: inline;" v-for="(item,i) in alertButtons">
        <ion-button class="custom-button" @click="buttonClicked(item.role)">{{ item.text }}</ion-button>
      </div>
    </div>
  </ion-content>
</template>

<script  setup>

// https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport

  import {
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonLabel,
    IonButtons,
    IonButton,
    IonItem,
    modalController,
  } from '@ionic/vue';

  import { defineComponent, ref , onMounted, watch } from 'vue';
  import { t } from '@/composables/translateText.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { scrollElement } from '@/composables/screenSize'

  const props = defineProps({
    header : {
      type : String,
      default : "Header"
    },
    message : {
      type : String,
      default : "Message"
    },
    alertType : {
      type : String, 
      default : "yesno"
    },
    task : {
      type : String,
      default : ""
    }
  })

  const footerHeight = 100
  const styleHeight = ref("height:" + footerHeight + "px;")

  const selectedValue = ref(props.initialValue)

  const connectionStore = useConnectionStore()
  const windowSizeStore = useWindowSizeStore()

  const whichMenu = localStorage.getItem("whichMenu")
  const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)
  const scalePercentage = connectionStore.getToolbarScalePercentage

  const radioButtonHeight = 50
  const useRadioButtonHeight = (showBigButtons.value) ? Math.floor( radioButtonHeight * scalePercentage / 100.0) :
                radioButtonHeight

  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  var currentScrollTop = 0
  var styleList = ref({})
  var styleTop = ref({})

  const alertYesNoButtons = [
    {
      text: t('NO'),
      role: 'no',
    },
    {
      text: t('YES'),
      role: 'confirm',
    }
  ]

   const alertOkButton = [
    {
      text: t('OK'),
      role: 'cancel'
    }
  ]
  
  const alertHeader = ref(props.header)
  const alertMessage = ref(props.message)
  var alertButtons = alertYesNoButtons

  switch (props.alertType) {
    default :
    case "alert" :
    case "error" :
      alertButtons = alertOkButton
      break
    case "yesno" :
      alertButtons = alertYesNoButtons
      break
    // case "boardmoves" :
    //   alertButtons = alertCopyBoardMovesButtons
    //   break
    // case "fenpgn" :
    //   alertButtons = alertFenPGNButtons
    //   break
    // case "whiteblack" :
    //   alertButtons = alertWhiteBlackButtons
    //   break

    // case "boardsource" :
    //   alertButtons = alertBoardSourceButtons
    //   break
    // case "masterdownload" :
    //   alertButtons = alertMasterDownloadButtons
    //   break
  }

  watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** Explorer -- window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** Explorer new window size",windowSizeRef.value)
    buildStyles()
  })

  onMounted(() => {
    var element = document.getElementById("page")
    if (element != null)
      element.style.setProperty("--radio_button_size", useRadioButtonHeight + "px");
  })

  function buttonClicked(role) {
    //console.log("on click",role)
    modalController.dismiss(role, props.task);

  }

</script>

<style scoped>

#page {
  --radio_button_size : 50px;
}

.button_class {
  height : var(--radio_button_size);
  width : 23%;
  margin-left : 1%;
  margin-right : 1%;
  background-color: #F5D8B1;
}

.choice_button_class {
  height : var(--radio_button_size);
  width : 50%;
  margin-left : 24%;
  margin-right : 24%;
  background-color: #F5D8B1;
}



.custom-button {
  --background: teal;       /* Teal background */
  --border-radius: 10px;    /* Rounded corners */
  --padding-top: 12px;      /* Optional: adjust height */
  --padding-bottom: 12px;   /* Optional: adjust height */
  --padding-start: 20px;    /* Optional: adjust width */
  --padding-end: 20px;      /* Optional: adjust width */
  --color: white;           /* Text color */
   height : var(--radio_button_size);
  width : 25%;
  margin-right : 2%;
  margin-left : 2%;
}

.custom-button:hover {
  --background : #329999;
}
</style>
